import * as React from 'react';

import { ClickAwayListener, Grid, Typography, makeStyles } from '@material-ui/core';

import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import CurrencyBitcoinOutlinedIcon from '@mui/icons-material/CurrencyBitcoinOutlined';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import Link from 'next/link';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    right: 0,
    width: '100%',
    maxWidth: '100%',
    backgroundColor: '#fff',
    top: '50px',
    boxShadow: '0px 2px 4px 4px #0003',
    borderRadius: '5px',
    zIndex: 999,
  },
  hr: {
    height: 1,
    backgroundColor: '#dadada',
  },
  items: {
    padding: 7,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ddd',
    },
  },
  texts: {
    fontSize: 14,
    color: '#000',
  },

  iconSize: {
    fontSize: '24px',
    color: '#06a19d',
    margin: '0 5px',
    marginBottom: '-7px',
  },
}));

const PaymentOptions = ({ data, open, setOpen, handleOpenPaymentDialog, ...props }) => {
  const classes = useStyles();
  const close = () => {
    setOpen(!open);
  };

  const yekpayLocation = {
    pathname: `/international-payment/${data.slug_en}`,
    orgId: data?.code,
    orgEnName: data.name_en,
  };

  return (
    <ClickAwayListener onClickAway={close}>
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.items} onClick={handleOpenPaymentDialog}>
          {data.has_wallet ? (
            <Typography variant="h5" className={classes.texts}>
              <PaymentsOutlinedIcon className={classes.iconSize} />
              حمایت ریالی
            </Typography>
          ) : ""}
        </Grid>
        {data.has_currency_payment ? (
          <>
            <Grid item xs={12} className={classes.hr} />
            <Grid item xs={12} className={classes.items}>
              <Link href={yekpayLocation}>
                <a>
                  <Typography variant="h5" className={classes.texts}>
                    <EuroOutlinedIcon className={classes.iconSize} />
                    حمایت ارزی
                  </Typography>
                </a>
              </Link>
            </Grid>
          </>
        ) : (
          ''
        )}
        {data.has_crypto_payment ? (
          <>
            <Grid item xs={12} className={classes.hr} />
            <Grid item xs={12} className={classes.items}>
              <Link href={`/crypto-payment/organization/${data.slug}`}>
                <a>
                  <Typography variant="h5" className={classes.texts}>
                    <CurrencyBitcoinOutlinedIcon className={classes.iconSize} />
                    حمایت رمز ارزی
                  </Typography>
                </a>
              </Link>
            </Grid>
          </>
        ) : (
          ''
        )}
      </Grid>
    </ClickAwayListener>
  );
};

export default PaymentOptions;
